import React from 'react';
import { useObservable } from 'react-use-observable';

import { Divider, Row, Col } from 'antd';

import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

import { ExportPartnerComissions } from './Export';

export const Details = () => {
  const [totalItems] = useObservable(() => partnerCommissionsService.getTotalItems(), []);
  const [totalGain] = useObservable(() => partnerCommissionsService.getTotalGain(), []);
  const [isLoading] = useObservable(() => partnerCommissionsService.isLoading(), []);

  const commissionsCount = `${totalItems} ${totalItems > 1 ? 'parceiros' : 'parceiro'}`;

  if (isLoading) return null;

  return (
    <Row
      id='commissions-partners-details'
      className='mb-4 w-full rounded-sm bg-white shadow-[0_1px_0_0_rgba(0,0,0,0.07)]'
      align='middle'
    >
      <Col>
        <div className='px-4 py-2'>
          <span className='text-base font-semibold'>{commissionsCount}</span>
        </div>
      </Col>
      <Divider type='vertical' className='h-10' />
      <Col>
        <div className='px-4 py-2'>
          <span className='text-base font-semibold'>
            Total das Comissões: <ColoredFormattedNumber value={totalGain} format='BRL' />
          </span>
        </div>
      </Col>
      <Divider type='vertical' className='h-10' />
      <PermissionHide action={'myeduzz:reports:exportar'}>
        <Col className='ml-auto'>
          <ExportPartnerComissions />
        </Col>
      </PermissionHide>
    </Row>
  );
};
